import React from 'react';
import { davidPhoto } from '../../data/reel';
import { SceneProps } from '../../types/reel';
import { punch, reveal } from '../../utils/reelMath';
import { SceneLayer } from './SceneLayer';
import { TypeText } from './TypeText';

/**
 * Source photo is ~826×864. Shown close to native size (≈1.15×) so it stays sharp,
 * framed wide enough to keep the torso, hands and chessboard in shot.
 */
const PHOTO_H = 1000;
const PHOTO_W = Math.round(PHOTO_H * (826 / 864));
export function FaceScene({
  time,
  scene
}: SceneProps) {
  const enter = reveal(time, scene.start, 0.45);
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.12} data-id="element-13" data-mp="2broq198ar22t">
      {({
      p
    }) => <div className="absolute inset-0 bg-cream" data-id="element-14" data-mp="26t3wttrgpinv">
          <div className="absolute right-[40px] top-[40px] overflow-hidden rounded-[32px] bg-[#E6E7E8]" style={{
        width: PHOTO_W,
        height: PHOTO_H,
        opacity: enter,
        transform: `translateY(${(1 - enter) * 24}px)`
      }} data-id="element-15" data-mp="26sltyeaao66z">
            <img src={davidPhoto} alt="" decoding="async" className="h-full w-full object-cover" style={{
          objectPosition: '50% 100%',
          transform: `scale(${punch(time, scene.start, 0.04, 0.5) + 0.03 * p})`,
          transformOrigin: '55% 30%',
          imageRendering: 'auto'
        }} data-id="element-16" data-mp="3j4z444hiqurh" />
          </div>
          <div className="absolute left-[150px] top-1/2 w-[700px] -translate-y-1/2" data-id="element-17" data-mp="34acegtsfdca2">
            <TypeText time={time} start={scene.start + 0.1} cps={36} segments="Senior Product Designer" className="block text-[92px] font-medium leading-[1.02] tracking-[-0.045em] text-ink" data-id="element-18" data-mp="2qio34sq02ru5" />
            <TypeText time={time} start={scene.start + 0.75} cps={44} segments="8+ years · AI · Fintech · E-commerce" className="mt-7 block text-[32px] tracking-[-0.02em] text-ink/75" data-id="element-19" data-mp="2gmb6pn32lzvp" />
          </div>
        </div>}
    </SceneLayer>;
}